import { useRef, useEffect } from "react";
import { Stack, List, ListItem, useTheme, useMediaQuery } from "@mui/material";
import { NewsList } from "../components/NewsList";
import { TopAbout } from "../components/TopAbout";
import { Text } from "../components/Text";
import { Nav } from "../components/Nav";

export const Top = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true; // 自動再生ポリシー対策
      videoRef.current.play().catch((error) => {
        console.error("動画の自動再生に失敗:", error);
      });
    }
  }, []);

  const handleVideoEnd = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  return (
    <>
      <Stack position="relative">
        <video
          ref={videoRef}
          src="/video/kv.mp4"
          onEnded={handleVideoEnd}
          onLoadedMetadata={() => videoRef.current?.play()}
          autoPlay
          loop
          muted
          playsInline
          width="100%"
          style={{
            aspectRatio: isMobile ? "15/8" : "20/7",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
        <Stack
          position="absolute"
          top={isMobile ? "11.46vw" : "50%"}
          width={isMobile ? "26.66vw" : "20.6vw"}
          left={isMobile ? "50%" : "20vw"}
          sx={{
            transform: isMobile ? "translateX(-50%)" : "translateY(-50%)",
          }}
        >
          <img src="/images/kv-logo.png" alt="" style={{ width: "100%" }} />
        </Stack>
        <Stack
          position="absolute"
          top={isMobile ? "30vw" : "50%"}
          width={isMobile ? "86.4vw" : "31.25vw"}
          right={isMobile ? "50%" : "20vw"}
          sx={{
            transform: isMobile ? "translateX(50%)" : "translateY(-50%)",
          }}
        >
          {isMobile ? (
            <img
              src="/images/kv-text_sp.png"
              alt=""
              style={{ width: "100%" }}
            />
          ) : (
            <img src="/images/kv-text.png" alt="" style={{ width: "100%" }} />
          )}
        </Stack>
      </Stack>
      <Stack
        position="sticky"
        top={0}
        left={0}
        zIndex={100}
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Nav />
      </Stack>
      <NewsList />
      <TopAbout title="Vision" background="#f6f6f6">
        <Stack>
          <Text
            variant="h3"
            color="primary"
            marginTop={isMobile ? 2 : 6.5}
            lineHeight={1.5}
          >
            「微生物の可能性を引き出し、{isMobile ? <br /> : null}
            持続可能な未来を創る」
          </Text>
          <Text marginTop={isMobile ? 2 : 3.8}>
            MycoGenomeは、真菌（微生物）の可能性を最大限に活用し、
            <br />
            食品・農業・医療・環境・エネルギーといった多様な分野でイノベーションを起こすことを目指しています。
            <br />
            私たちは、従来のゲノム編集技術の限界を超え、
            <br />
            非遺伝子組換え型の安全かつ高精度な微生物改変技術を提供することで、社会の持続可能な発展に貢献します。
            <br />
            微生物バイオテクノロジーの新たな可能性を切り拓き、
            <br />
            産業界とともに未来の社会を構築することが私たちのビジョンです。
          </Text>
        </Stack>
      </TopAbout>
      <TopAbout title="Mission" image="/images/mission.png">
        <Stack>
          <Stack>
            <Text
              variant="h3"
              color="primary"
              marginTop={isMobile ? 2 : 6.5}
              lineHeight={1.5}
            >
              「真菌ゲノム編集技術で産業を革新し、
              {isMobile ? null : <br />}
              社会課題を解決する」
            </Text>

            <List sx={{ marginTop: isMobile ? 2 : 4 }}>
              {[
                "食品の発酵技術を進化させ、食の未来を創る",
                "農業・畜産分野で持続可能な生産技術を支援する",
                "バイオ燃料の効率化に貢献し、環境負荷を低減する",
                "医薬品・化学分野で有用な微生物開発を促進する",
              ].map((text, index) => {
                return (
                  <ListItem
                    key={index}
                    sx={{
                      padding: 0,
                      "&::before": {
                        content: "'⚫︎'",
                        color: "#ffbd00",
                        paddingRight: 1,
                      },
                    }}
                  >
                    <Text lineHeight={1.7} fontWeight="bold">
                      {text}
                    </Text>
                  </ListItem>
                );
              })}
            </List>

            <Text marginTop={2}>
              MycoGenomeは、独自の「MycoEdita」技術を活用し、
              <br />
              これまでにないゲノム編集手法を確立。
              <br />
              従来のCRISPR/Cas9技術に依存せず、
              <br />
              産業応用に適した非遺伝子組換え型の技術を提供することで、
              <br />
              微生物バイオテクノロジーの新たな市場を創出します。
            </Text>
          </Stack>
        </Stack>
      </TopAbout>
      {/* <TopAbout image="/images/fungi.png" moreHref="/fungi">
        <Stack>
          <Text variant="h3" color="primary" lineHeight={1.5}>
            真菌とは
          </Text>
          <Text marginTop={2} lineHeight={2}>
            真菌は、カビ・酵母・キノコなどを含む微生物の一種で、
            <br />
            植物や動物とは異なる独自の進化を遂げた生物です。
            <br />
            真菌は土壌、空気、水中など地球上のあらゆる環境に生息し、
            <br />
            発酵食品の生産や抗生物質の生成など、私たちの生活に密接に関わっています。
          </Text>
        </Stack>
      </TopAbout>
      <TopAbout
        background="#f6f6f6"
        image="/images/technology.png"
        moreHref="/technology"
        reverse
      >
        <Stack>
          <Text variant="h3" color="primary" lineHeight={1.5}>
            技術紹介
          </Text>
          <Text marginTop={2} lineHeight={2}>
            MycoGenomeのゲノム編集技術では、 <br />
            細胞内で自律的に複製できるベクターを使用します。 <br />
            これにより、遺伝子改変後に不要なDNAを細胞から取り除くことが可能になり、{" "}
            <br />
            非遺伝子組換え型の微生物を作製できます。
          </Text>
        </Stack>
      </TopAbout> */}
    </>
  );
};
